import { Checkbox } from '@mui/material';
import { useState } from 'react';
import { TableInput } from '../../../../../components/common';

interface IProps {
  moduleData: any;
  isView: boolean;
  processData: any;
}

const TBody = ({ moduleData, isView, processData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData.employees.map((employee: any, index: any) => (
        <tr>
          <td>{index + 1}</td>
          <td>{employee.employee_id?.employee_name}</td>
          <td>{employee.employee_id?.employee_code}</td>
          <td>{employee.employee_id?.level}</td>
          {processData.map((process: any) => (
            <td>
              {isView ? (
                employee[process._id] && '✓'
              ) : (
                <Checkbox
                  name="process_name"
                  color="primary"
                  checked={employee.process_ids.includes(process._id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      employee.process_ids.push(process._id);
                    } else {
                      const index = employee.process_ids.indexOf(process._id);
                      if (index !== -1) employee.process_ids.splice(index, 1);
                    }
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
          ))}
          <td>
            <TableInput
              name="remarks"
              type="text"
              value={employee.remarks}
              onChange={(e) => {
                employee.remarks = e.target.value;
                setRender((prev) => !prev);
              }}
              isView={isView}
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default TBody;
